export default [
  {
    text: 'Andorra',
    id: 'Andorra',
  },
  {
    text: 'United Arab Emirates',
    id: 'United Arab Emirates',
  },
  {
    text: 'Afghanistan',
    id: 'Afghanistan',
  },
  {
    text: 'Antigua and Barbuda',
    id: 'Antigua and Barbuda',
  },
  {
    text: 'Anguilla',
    id: 'Anguilla',
  },
  {
    text: 'Albania',
    id: 'Albania',
  },
  {
    text: 'Armenia',
    id: 'Armenia',
  },
  {
    text: 'Netherlands Antilles',
    id: 'Netherlands Antilles',
  },
  {
    text: 'Angola',
    id: 'Angola',
  },
  {
    text: 'Antarctica',
    id: 'Antarctica',
  },
  {
    text: 'Argentina',
    id: 'Argentina',
  },
  {
    text: 'American Samoa',
    id: 'American Samoa',
  },
  {
    text: 'Austria',
    id: 'Austria',
  },
  {
    text: 'Australia',
    id: 'Australia',
  },
  {
    text: 'Aruba',
    id: 'Aruba',
  },
  {
    text: 'Aland Islands',
    id: 'Aland Islands',
  },
  {
    text: 'Azerbaijan',
    id: 'Azerbaijan',
  },
  {
    text: 'Bosnia and Herzegovina',
    id: 'Bosnia and Herzegovina',
  },
  {
    text: 'Barbados',
    id: 'Barbados',
  },
  {
    text: 'Bangladesh',
    id: 'Bangladesh',
  },
  {
    text: 'Belgium',
    id: 'Belgium',
  },
  {
    text: 'Burkina Faso',
    id: 'Burkina Faso',
  },
  {
    text: 'Bulgaria',
    id: 'Bulgaria',
  },
  {
    text: 'Bahrain',
    id: 'Bahrain',
  },
  {
    text: 'Burundi',
    id: 'Burundi',
  },
  {
    text: 'Benin',
    id: 'Benin',
  },
  {
    text: 'Saint Barthelemy',
    id: 'Saint Barthelemy',
  },
  {
    text: 'Bermuda',
    id: 'Bermuda',
  },
  {
    text: 'Brunei Darussalam',
    id: 'Brunei Darussalam',
  },
  {
    text: 'Bolivia',
    id: 'Bolivia',
  },
  {
    text: 'Dutch Caribbean',
    id: 'Dutch Caribbean',
  },
  {
    text: 'Brazil',
    id: 'Brazil',
  },
  {
    text: 'Bahamas',
    id: 'Bahamas',
  },
  {
    text: 'Bhutan',
    id: 'Bhutan',
  },
  {
    text: 'Bouvet Island',
    id: 'Bouvet Island',
  },
  {
    text: 'Botswana',
    id: 'Botswana',
  },
  {
    text: 'Belarus',
    id: 'Belarus',
  },
  {
    text: 'Belize',
    id: 'Belize',
  },
  {
    text: 'Canada',
    id: 'Canada',
  },
  {
    text: 'Cocos (Keeling) Islands',
    id: 'Cocos (Keeling) Islands',
  },
  {
    text: 'Congo, The Democratic Republic of the',
    id: 'Congo, The Democratic Republic of the',
  },
  {
    text: 'Central African Republic',
    id: 'Central African Republic',
  },
  {
    text: 'Congo',
    id: 'Congo',
  },
  {
    text: 'Switzerland',
    id: 'Switzerland',
  },
  {
    text: "Cote d'Ivoire",
    id: "Cote d'Ivoire",
  },
  {
    text: 'Cook Islands',
    id: 'Cook Islands',
  },
  {
    text: 'Chile',
    id: 'Chile',
  },
  {
    text: 'Cameroon',
    id: 'Cameroon',
  },
  {
    text: 'China',
    id: 'China',
  },
  {
    text: 'Colombia',
    id: 'Colombia',
  },
  {
    text: 'Costa Rica',
    id: 'Costa Rica',
  },
  {
    text: 'Obsolete see RS or ME territory',
    id: 'Obsolete see RS or ME territory',
  },
  {
    text: 'Cuba',
    id: 'Cuba',
  },
  {
    text: 'Cape Verde',
    id: 'Cape Verde',
  },
  {
    text: 'Curacao',
    id: 'Curacao',
  },
  {
    text: 'Christmas Island',
    id: 'Christmas Island',
  },
  {
    text: 'Cyprus',
    id: 'Cyprus',
  },
  {
    text: 'Czech Republic',
    id: 'Czech Republic',
  },
  {
    text: 'Germany',
    id: 'Germany',
  },
  {
    text: 'Djibouti',
    id: 'Djibouti',
  },
  {
    text: 'Denmark',
    id: 'Denmark',
  },
  {
    text: 'Dominica',
    id: 'Dominica',
  },
  {
    text: 'Dominican Republic',
    id: 'Dominican Republic',
  },
  {
    text: 'Algeria',
    id: 'Algeria',
  },
  {
    text: 'Ecuador',
    id: 'Ecuador',
  },
  {
    text: 'Estonia',
    id: 'Estonia',
  },
  {
    text: 'Egypt',
    id: 'Egypt',
  },
  {
    text: 'Western Sahara',
    id: 'Western Sahara',
  },
  {
    text: 'Eritrea',
    id: 'Eritrea',
  },
  {
    text: 'Spain',
    id: 'Spain',
  },
  {
    text: 'Ethiopia',
    id: 'Ethiopia',
  },
  {
    text: 'Finland',
    id: 'Finland',
  },
  {
    text: 'Fiji',
    id: 'Fiji',
  },
  {
    text: 'Falkland Islands (Malvinas)',
    id: 'Falkland Islands (Malvinas)',
  },
  {
    text: 'Micronesia, Federated States of',
    id: 'Micronesia, Federated States of',
  },
  {
    text: 'Faroe Islands',
    id: 'Faroe Islands',
  },
  {
    text: 'France',
    id: 'France',
  },
  {
    text: 'Obsolete see FR territory',
    id: 'Obsolete see FR territory',
  },
  {
    text: 'Gabon',
    id: 'Gabon',
  },
  {
    text: 'United Kingdom',
    id: 'United Kingdom',
  },
  {
    text: 'Grenada',
    id: 'Grenada',
  },
  {
    text: 'Georgia',
    id: 'Georgia',
  },
  {
    text: 'French Guiana',
    id: 'French Guiana',
  },
  {
    text: 'Guernsey',
    id: 'Guernsey',
  },
  {
    text: 'Ghana',
    id: 'Ghana',
  },
  {
    text: 'Gibraltar',
    id: 'Gibraltar',
  },
  {
    text: 'Greenland',
    id: 'Greenland',
  },
  {
    text: 'Gambia',
    id: 'Gambia',
  },
  {
    text: 'Guinea',
    id: 'Guinea',
  },
  {
    text: 'Guadeloupe',
    id: 'Guadeloupe',
  },
  {
    text: 'Equatorial Guinea',
    id: 'Equatorial Guinea',
  },
  {
    text: 'Greece',
    id: 'Greece',
  },
  {
    text: 'South Georgia and the South Sandwich Islands',
    id: 'South Georgia and the South Sandwich Islands',
  },
  {
    text: 'Guatemala',
    id: 'Guatemala',
  },
  {
    text: 'Guam',
    id: 'Guam',
  },
  {
    text: 'Guinea-Bissau',
    id: 'Guinea-Bissau',
  },
  {
    text: 'Guyana',
    id: 'Guyana',
  },
  {
    text: 'Hong Kong',
    id: 'Hong Kong',
  },
  {
    text: 'Heard Island and McDonald Islands',
    id: 'Heard Island and McDonald Islands',
  },
  {
    text: 'Honduras',
    id: 'Honduras',
  },
  {
    text: 'Croatia',
    id: 'Croatia',
  },
  {
    text: 'Haiti',
    id: 'Haiti',
  },
  {
    text: 'Hungary',
    id: 'Hungary',
  },
  {
    text: 'Indonesia',
    id: 'Indonesia',
  },
  {
    text: 'Ireland',
    id: 'Ireland',
  },
  {
    text: 'Israel',
    id: 'Israel',
  },
  {
    text: 'Isle of Man',
    id: 'Isle of Man',
  },
  {
    text: 'India',
    id: 'India',
  },
  {
    text: 'British Indian Ocean Territory',
    id: 'British Indian Ocean Territory',
  },
  {
    text: 'Iraq',
    id: 'Iraq',
  },
  {
    text: 'Iran, Islamic Republic of',
    id: 'Iran, Islamic Republic of',
  },
  {
    text: 'Iceland',
    id: 'Iceland',
  },
  {
    text: 'Italy',
    id: 'Italy',
  },
  {
    text: 'Jersey',
    id: 'Jersey',
  },
  {
    text: 'Jamaica',
    id: 'Jamaica',
  },
  {
    text: 'Jordan',
    id: 'Jordan',
  },
  {
    text: 'Japan',
    id: 'Japan',
  },
  {
    text: 'Kenya',
    id: 'Kenya',
  },
  {
    text: 'Kyrgyzstan',
    id: 'Kyrgyzstan',
  },
  {
    text: 'Cambodia',
    id: 'Cambodia',
  },
  {
    text: 'Kiribati',
    id: 'Kiribati',
  },
  {
    text: 'Comoros',
    id: 'Comoros',
  },
  {
    text: 'Saint Kitts and Nevis',
    id: 'Saint Kitts and Nevis',
  },
  {
    text: "Korea, Democratic People's Republic of",
    id: "Korea, Democratic People's Republic of",
  },
  {
    text: 'Korea, Republic of',
    id: 'Korea, Republic of',
  },
  {
    text: 'Kuwait',
    id: 'Kuwait',
  },
  {
    text: 'Cayman Islands',
    id: 'Cayman Islands',
  },
  {
    text: 'Kazakhstan',
    id: 'Kazakhstan',
  },
  {
    text: "Lao People's Democratic Republic",
    id: "Lao People's Democratic Republic",
  },
  {
    text: 'Lebanon',
    id: 'Lebanon',
  },
  {
    text: 'Saint Lucia',
    id: 'Saint Lucia',
  },
  {
    text: 'Liechtenstein',
    id: 'Liechtenstein',
  },
  {
    text: 'Sri Lanka',
    id: 'Sri Lanka',
  },
  {
    text: 'Liberia',
    id: 'Liberia',
  },
  {
    text: 'Lesotho',
    id: 'Lesotho',
  },
  {
    text: 'Lithuania',
    id: 'Lithuania',
  },
  {
    text: 'Luxembourg',
    id: 'Luxembourg',
  },
  {
    text: 'Latvia',
    id: 'Latvia',
  },
  {
    text: 'Obsolete see LT territory',
    id: 'Obsolete see LT territory',
  },
  {
    text: 'Libyan Arab Jamahiriya',
    id: 'Libyan Arab Jamahiriya',
  },
  {
    text: 'Morocco',
    id: 'Morocco',
  },
  {
    text: 'Monaco',
    id: 'Monaco',
  },
  {
    text: 'Moldova, Republic of',
    id: 'Moldova, Republic of',
  },
  {
    text: 'Montenegro',
    id: 'Montenegro',
  },
  {
    text: 'Saint Martin (French part)',
    id: 'Saint Martin (French part)',
  },
  {
    text: 'Madagascar',
    id: 'Madagascar',
  },
  {
    text: 'Marshall Islands',
    id: 'Marshall Islands',
  },
  {
    text: 'Macedonia, The Former Yugoslav Republic of',
    id: 'Macedonia, The Former Yugoslav Republic of',
  },
  {
    text: 'Mali',
    id: 'Mali',
  },
  {
    text: 'Myanmar',
    id: 'Myanmar',
  },
  {
    text: 'Mongolia',
    id: 'Mongolia',
  },
  {
    text: 'Macao',
    id: 'Macao',
  },
  {
    text: 'Northern Mariana Islands',
    id: 'Northern Mariana Islands',
  },
  {
    text: 'Martinique',
    id: 'Martinique',
  },
  {
    text: 'Mauritania',
    id: 'Mauritania',
  },
  {
    text: 'Montserrat',
    id: 'Montserrat',
  },
  {
    text: 'Malta',
    id: 'Malta',
  },
  {
    text: 'Mauritius',
    id: 'Mauritius',
  },
  {
    text: 'Maldives',
    id: 'Maldives',
  },
  {
    text: 'Malawi',
    id: 'Malawi',
  },
  {
    text: 'Mexico',
    id: 'Mexico',
  },
  {
    text: 'Malaysia',
    id: 'Malaysia',
  },
  {
    text: 'Mozambique',
    id: 'Mozambique',
  },
  {
    text: 'Namibia',
    id: 'Namibia',
  },
  {
    text: 'New Caledonia',
    id: 'New Caledonia',
  },
  {
    text: 'Niger',
    id: 'Niger',
  },
  {
    text: 'Norfolk Island',
    id: 'Norfolk Island',
  },
  {
    text: 'Nigeria',
    id: 'Nigeria',
  },
  {
    text: 'Nicaragua',
    id: 'Nicaragua',
  },
  {
    text: 'Netherlands',
    id: 'Netherlands',
  },
  {
    text: 'Norway',
    id: 'Norway',
  },
  {
    text: 'Nepal',
    id: 'Nepal',
  },
  {
    text: 'Nauru',
    id: 'Nauru',
  },
  {
    text: 'Niue',
    id: 'Niue',
  },
  {
    text: 'New Zealand',
    id: 'New Zealand',
  },
  {
    text: 'Oman',
    id: 'Oman',
  },
  {
    text: 'Panama',
    id: 'Panama',
  },
  {
    text: 'Peru',
    id: 'Peru',
  },
  {
    text: 'French Polynesia',
    id: 'French Polynesia',
  },
  {
    text: 'Papua New Guinea',
    id: 'Papua New Guinea',
  },
  {
    text: 'Philippines',
    id: 'Philippines',
  },
  {
    text: 'Pakistan',
    id: 'Pakistan',
  },
  {
    text: 'Poland',
    id: 'Poland',
  },
  {
    text: 'Saint Pierre and Miquelon',
    id: 'Saint Pierre and Miquelon',
  },
  {
    text: 'Pitcairn',
    id: 'Pitcairn',
  },
  {
    text: 'Puerto Rico',
    id: 'Puerto Rico',
  },
  {
    text: 'Palestinian Territory,Occupied',
    id: 'Palestinian Territory,Occupied',
  },
  {
    text: 'Portugal',
    id: 'Portugal',
  },
  {
    text: 'Palau',
    id: 'Palau',
  },
  {
    text: 'Paraguay',
    id: 'Paraguay',
  },
  {
    text: 'Qatar',
    id: 'Qatar',
  },
  {
    text: 'Reunion',
    id: 'Reunion',
  },
  {
    text: 'Romania',
    id: 'Romania',
  },
  {
    text: 'Serbia',
    id: 'Serbia',
  },
  {
    text: 'Russian Federation',
    id: 'Russian Federation',
  },
  {
    text: 'Rwanda',
    id: 'Rwanda',
  },
  {
    text: 'Saudi Arabia',
    id: 'Saudi Arabia',
  },
  {
    text: 'Solomon Islands',
    id: 'Solomon Islands',
  },
  {
    text: 'Seychelles',
    id: 'Seychelles',
  },
  {
    text: 'Sudan',
    id: 'Sudan',
  },
  {
    text: 'Sweden',
    id: 'Sweden',
  },
  {
    text: 'Singapore',
    id: 'Singapore',
  },
  {
    text: 'Saint Helena',
    id: 'Saint Helena',
  },
  {
    text: 'Slovenia',
    id: 'Slovenia',
  },
  {
    text: 'Svalbard and Jan Mayen',
    id: 'Svalbard and Jan Mayen',
  },
  {
    text: 'Slovakia',
    id: 'Slovakia',
  },
  {
    text: 'Sierra Leone',
    id: 'Sierra Leone',
  },
  {
    text: 'San Marino',
    id: 'San Marino',
  },
  {
    text: 'Senegal',
    id: 'Senegal',
  },
  {
    text: 'Somalia',
    id: 'Somalia',
  },
  {
    text: 'Suriname',
    id: 'Suriname',
  },
  {
    text: 'Sao Tome and Principe',
    id: 'Sao Tome and Principe',
  },
  {
    text: 'El Salvador',
    id: 'El Salvador',
  },
  {
    text: 'Sint Maartin (Dutch Part), SX',
    id: 'Sint Maartin (Dutch Part), SX',
  },
  {
    text: 'Syrian Arab Republic',
    id: 'Syrian Arab Republic',
  },
  {
    text: 'Swaziland',
    id: 'Swaziland',
  },
  {
    text: 'Turks and Caicos Islands',
    id: 'Turks and Caicos Islands',
  },
  {
    text: 'Chad',
    id: 'Chad',
  },
  {
    text: 'French Southern Territories',
    id: 'French Southern Territories',
  },
  {
    text: 'Togo',
    id: 'Togo',
  },
  {
    text: 'Thailand',
    id: 'Thailand',
  },
  {
    text: 'Tajikistan',
    id: 'Tajikistan',
  },
  {
    text: 'Tokelau',
    id: 'Tokelau',
  },
  {
    text: 'Timor-Leste',
    id: 'Timor-Leste',
  },
  {
    text: 'Turkmenistan',
    id: 'Turkmenistan',
  },
  {
    text: 'Tunisia',
    id: 'Tunisia',
  },
  {
    text: 'Tonga',
    id: 'Tonga',
  },
  {
    text: 'Obsolete see TL territory',
    id: 'Obsolete see TL territory',
  },
  {
    text: 'Türkiye',
    id: 'Türkiye',
  },
  {
    text: 'Trinidad and Tobago',
    id: 'Trinidad and Tobago',
  },
  {
    text: 'Tuvalu',
    id: 'Tuvalu',
  },
  {
    text: 'Taiwan',
    id: 'Taiwan',
  },
  {
    text: 'Tanzania, United Republic of',
    id: 'Tanzania, United Republic of',
  },
  {
    text: 'Ukraine',
    id: 'Ukraine',
  },
  {
    text: 'Uganda',
    id: 'Uganda',
  },
  {
    text: 'United States',
    id: 'United States',
  },
  {
    text: 'Uruguay',
    id: 'Uruguay',
  },
  {
    text: 'Uzbekistan',
    id: 'Uzbekistan',
  },
  {
    text: 'Holy See (Vatican City State)',
    id: 'Holy See (Vatican City State)',
  },
  {
    text: 'Saint Vincent and the Grenadines',
    id: 'Saint Vincent and the Grenadines',
  },
  {
    text: 'Venezuela',
    id: 'Venezuela',
  },
  {
    text: 'Virgin Islands, British',
    id: 'Virgin Islands, British',
  },
  {
    text: 'Virgin Islands, U.S.',
    id: 'Virgin Islands, U.S.',
  },
  {
    text: 'Viet Nam',
    id: 'Viet Nam',
  },
  {
    text: 'Vanuatu',
    id: 'Vanuatu',
  },
  {
    text: 'Wallis and Futuna',
    id: 'Wallis and Futuna',
  },
  {
    text: 'Samoa',
    id: 'Samoa',
  },
  {
    text: 'Yemen',
    id: 'Yemen',
  },
  {
    text: 'Mayotte',
    id: 'Mayotte',
  },
  {
    text: 'Obsolete see CS territory',
    id: 'Obsolete see CS territory',
  },
  {
    text: 'South Africa',
    id: 'South Africa',
  },
  {
    text: 'Zambia',
    id: 'Zambia',
  },
  {
    text: 'Obsolete see CD territory',
    id: 'Obsolete see CD territory',
  },
  {
    text: 'Zimbabwe',
    id: 'Zimbabwe',
  },
];
